import { useMemo } from 'react';

import { GlobalAdminMenuItem } from '@/layouts/layout.types';

export const globalAdminRoutes = Object.freeze({
  allSubscriptions: '/global_admin/all_subscriptions',
  allSubscriptionsEdit: '/global_admin/all_subscriptions/$id',
  allUsers: '/global_admin/all_users',
  appLookups: '/global_admin/app_lookups',
  appModules: '/global_admin/app_modules',
  scheduler: '/global_admin/scheduler',
  contentBuilder: '/global_admin/content_builder',
  system: '/global_admin/system'
});

export const newDesignPaths = [
  '/updates',
  '/collaborate',
  '/sstra',
  '/report/our_journey',
  '/report/our_calendar',
  '/report/our_songline',
  '/admin/subscription',
  '/admin/business_units',
  '/global_admin',
  '/profile'
];

export const useGlobalAdminMenuItems = () => {
  const globalAdminMenuItems = useMemo<GlobalAdminMenuItem[]>(
    () => [
      {
        name: 'Business Units',
        description: 'Manage business units.',
        url: '/admin/business_units'
      },
      {
        name: 'All Subscriptions',
        description: 'Manage All Subscriptions.',
        url: globalAdminRoutes.allSubscriptions
      },
      {
        name: 'All Users',
        description: 'Manage All Users.',
        url: globalAdminRoutes.allUsers
      },
      {
        name: 'App Lookups',
        description: 'Manage system configurations',
        url: globalAdminRoutes.appLookups
      },
      {
        name: 'App Modules',
        description: 'Manage system modules',
        url: globalAdminRoutes.appModules
      },
      {
        name: 'Scheduler',
        description: 'Scheduler',
        url: globalAdminRoutes.scheduler
      },
      {
        name: 'Content Builder',
        description: 'Content Builder',
        url: globalAdminRoutes.contentBuilder
      },
      {
        name: 'System',
        description: 'System Info',
        url: globalAdminRoutes.system
      }
    ],
    []
  );

  return { globalAdminMenuItems };
};
